export const BytheFootSection = {
    panelTitle: "Cost Worksheet",
    panelDescription: "By the Foot worksheet",
    tableHead: "BY THE FOOT...LABOR & MATERIAL BUILT IN SECTION",
    editType: "edit",
    close:"Close",
    keyValues: {
        totalTM: 'totalTM',
        totalCost: 'totalCost'
    },
    tableColumnNames: {
        costpersquarefeet: "Cost Per Square/Linear Feet",
        totalsquarefeet: "Total Square/Linear Feet",
        equalSimbol: "=",
        laborFinal: "Labor Final"
    },
    placeHolderValues: {
        totalsquarefeet: "0",
        costpersquarefeet: "0.00",
        laborFinal: "0.00"
    }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/utils/e-commerce/by-the-foot.ts